import { BG01_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/BG01/plasmic-props";
import { BG02_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/BG02/plasmic-props";
import { BG03_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/BG03/plasmic-props";

import {
  BENTO_GRID_VARIANTS,
  BG_01 as BENTO_GRID_BG01,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const BENTO_GRID_PLASMIC_PROPS = {
  variant: {
    type: "choice",
    options: BENTO_GRID_VARIANTS,
    defaultValue: BENTO_GRID_BG01,
    description: "Select bento grid variant",
  },
  ...BG01_PLASMIC_PROPS,
  ...BG02_PLASMIC_PROPS,
  ...BG03_PLASMIC_PROPS,
  className: {
    type: "string",
    defaultValue: "",
  },
};
